var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrong-page" }, [
    _c("header", { staticClass: "wp-hero" }, [
      _c("div", { staticClass: "hero-top" }, [
        _c("span", { staticClass: "hero-back", on: { click: _vm.goBack } }, [
          _vm._v("‹"),
        ]),
        _c("span", { staticClass: "hero-title" }, [_vm._v("错题本")]),
        _c("span", { staticClass: "hero-back ghost" }),
      ]),
      _c("div", { staticClass: "hero-nums" }, [
        _c("div", { staticClass: "hn" }, [
          _c("p", { staticClass: "hn-label" }, [_vm._v("错题总数")]),
          _c("p", { staticClass: "hn-num" }, [
            _vm._v(_vm._s(_vm.stat.total)),
            _c("em", [_vm._v("题")]),
          ]),
        ]),
        _c("div", { staticClass: "hn" }, [
          _c("p", { staticClass: "hn-label" }, [_vm._v("未掌握")]),
          _c("p", { staticClass: "hn-num" }, [
            _c("b", { staticClass: "warn" }, [
              _vm._v(_vm._s(_vm.stat.unmastered)),
            ]),
            _c("em", [_vm._v("题")]),
          ]),
        ]),
        _c("div", { staticClass: "hn" }, [
          _c("p", { staticClass: "hn-label" }, [_vm._v("掌握率")]),
          _c("p", { staticClass: "hn-num" }, [
            _vm._v(_vm._s(_vm.stat.rate)),
            _c("em", [_vm._v("%")]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "hero-bar" }, [
        _c("i", { style: { width: _vm.stat.rate + "%" } }),
      ]),
      _c("p", { staticClass: "hero-tip" }, [
        _vm._v("先把错 2 次以上的题过一遍，性价比最高"),
      ]),
    ]),
    _c("main", { staticClass: "wp-body" }, [
      _c(
        "div",
        { staticClass: "chips" },
        [
          _c(
            "span",
            {
              staticClass: "chip",
              class: { on: _vm.subject === "all" },
              on: {
                click: function ($event) {
                  _vm.subject = "all"
                },
              },
            },
            [_vm._v(" 全部"), _c("em", [_vm._v(_vm._s(_vm.stat.total))])]
          ),
          _vm._l(_vm.facets, function (f) {
            return _c(
              "span",
              {
                key: f.key,
                staticClass: "chip",
                class: { on: _vm.subject === f.key },
                on: {
                  click: function ($event) {
                    _vm.subject = f.key
                  },
                },
              },
              [
                _vm._v(" " + _vm._s(f.name)),
                _c("em", [_vm._v(_vm._s(f.count))]),
              ]
            )
          }),
        ],
        2
      ),
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "span",
          {
            staticClass: "only",
            class: { on: _vm.onlyUnmastered },
            on: {
              click: function ($event) {
                _vm.onlyUnmastered = !_vm.onlyUnmastered
              },
            },
          },
          [_c("i", { staticClass: "box" }), _vm._v("只看未掌握 ")]
        ),
        _c("span", { staticClass: "toolbar-count" }, [
          _vm._v("共 " + _vm._s(_vm.list.length) + " 题"),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "q-list" },
        [
          _vm._l(_vm.list, function (q) {
            return _c(
              "div",
              {
                key: q.id,
                staticClass: "q-card",
                class: { mastered: q.mastered },
              },
              [
                _c("div", { staticClass: "q-head" }, [
                  _c(
                    "span",
                    {
                      staticClass: "q-badge",
                      style: { background: q.meta.bg, color: q.meta.fg },
                    },
                    [_vm._v(" " + _vm._s(q.meta.short) + " ")]
                  ),
                  _c("span", { staticClass: "q-tag" }, [_vm._v(_vm._s(q.tag))]),
                  q.times > 1
                    ? _c("span", { staticClass: "q-times" }, [
                        _vm._v("错 " + _vm._s(q.times) + " 次"),
                      ])
                    : _vm._e(),
                  q.mastered
                    ? _c("span", { staticClass: "q-ok" }, [_vm._v("已掌握")])
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "q-stem" }, [_vm._v(_vm._s(q.stem))]),
                _c("div", { staticClass: "q-ans" }, [
                  _c("div", { staticClass: "qa-item bad" }, [
                    _c("span", { staticClass: "qa-label" }, [
                      _vm._v("我的答案"),
                    ]),
                    _c("span", { staticClass: "qa-val" }, [
                      _vm._v(_vm._s(q.mine)),
                    ]),
                  ]),
                  _c("div", { staticClass: "qa-item good" }, [
                    _c("span", { staticClass: "qa-label" }, [
                      _vm._v("正确答案"),
                    ]),
                    _c("span", { staticClass: "qa-val" }, [
                      _vm._v(_vm._s(q.right)),
                    ]),
                  ]),
                ]),
                _c("p", { staticClass: "q-from" }, [
                  _vm._v(_vm._s(q.from) + " · " + _vm._s(q.date)),
                ]),
                _vm.openId === q.id
                  ? _c("div", { staticClass: "q-an" }, [
                      _c("p", { staticClass: "q-an-title" }, [_vm._v("解析")]),
                      _c("p", { staticClass: "q-an-text" }, [
                        _vm._v(_vm._s(q.analysis)),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "q-foot" }, [
                  _c(
                    "span",
                    {
                      staticClass: "q-more",
                      on: {
                        click: function ($event) {
                          return _vm.toggleOpen(q.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.openId === q.id ? "收起解析 ⌃" : "看解析 ⌄"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "q-mark",
                      class: { on: q.mastered },
                      on: {
                        click: function ($event) {
                          return _vm.toggleMastered(q)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(q.mastered ? "取消已掌握" : "标记已掌握") +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]
            )
          }),
          !_vm.list.length
            ? _c("p", { staticClass: "empty" }, [_vm._v("这个筛选下没有错题")])
            : _vm._e(),
        ],
        2
      ),
      _c("p", { staticClass: "tip" }, [
        _vm._v("演示数据 · 接入题库后按同样的结构返回即可"),
      ]),
    ]),
    _vm.toast
      ? _c("p", { staticClass: "toast-tip" }, [_vm._v(_vm._s(_vm.toast))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }